import React from 'react'
import { useTranslation } from 'react-i18next'
import { Plus, Search, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { RFQ_STATUSES, RFQ_STATUS_KEY } from '../lib/labels'
import type { RfqFilterState } from '../lib/rfq'
import type { CostRfqStatus } from '../types'

const ALL = 'all'

interface Props { count: number; filter: RfqFilterState; onFilterChange: (filter: RfqFilterState) => void; canCreate: boolean; onCreate: () => void }

/** Part D spec §8: count, status filter, search, "Nová poptávka". */
const RfqsToolbar: React.FC<Props> = ({ count, filter, onFilterChange, canCreate, onCreate }) => {
  const { t } = useTranslation()
  const set = (patch: Partial<RfqFilterState>) => onFilterChange({ ...filter, ...patch })
  return (
    <div className="flex flex-wrap items-center gap-3 py-2">
      <div className="flex items-center gap-1">
        <span className="text-lg font-bold">{count}</span>
        <span className="text-sm text-muted-foreground">{t('Common_total')}</span>
      </div>
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2">
        <Select value={filter.status ?? ALL} onValueChange={(v) => set({ status: v === ALL ? null : (v as CostRfqStatus) })}>
          <SelectTrigger className="h-8 w-auto min-w-[150px] text-sm"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL}>{t('CostControl_filter_all_statuses')}</SelectItem>
            {RFQ_STATUSES.map((s) => <SelectItem key={s} value={s}>{t(RFQ_STATUS_KEY[s])}</SelectItem>)}
          </SelectContent>
        </Select>
        <div className="relative">
          <Search className="absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input value={filter.search} onChange={(e) => set({ search: e.target.value })} placeholder={t('CostControl_rfq_search')} className="h-8 w-[200px] pl-8 pr-8 text-sm" />
          {filter.search && (
            <button type="button" className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground" onClick={() => set({ search: '' })} aria-label={t('CostControl_contracts_search_clear')}>
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
      {canCreate && (
        <Button size="sm" className="h-8" onClick={onCreate}>
          <Plus className="h-4 w-4" />
          {t('CostControl_rfq_new')}
        </Button>
      )}
    </div>
  )
}
export default RfqsToolbar
